import SignImg from "../image/guidstamp.png";

export default function ConflictOfInterestPage({ inspectorDetails }) {
  return (
    <div className="p-4 space-y-4 text-[15px] px-10 mx-5">
      
      <p>
        This Agreement is between AIPL and {inspectorDetails?.inspectorName || "_____"} an individual (“EMPLOYEE”) working at DYC Global
        Inspections Private Limited.
      </p>

      <p>
        WHEREAS, AIPL has committed to Impartiality in its decisions related to the inspection and
        expediting activities carried out.
      </p>

      <div>
        <strong>SELF INTEREST THREATS</strong>
        <ul className="list-disc pl-6">
          <li>
            The EMPLOYEE shall not act on their own interest nor review the work done by themselves
            or by their colleagues.
          </li>
        </ul>
      </div>

      <div>
        <strong>INTIMIDATION THREATS</strong>
        <ul className="list-disc pl-6">
          <li>
            The EMPLOYEE shall not get influenced by a close relationship with a person who is a
            service provider to our Client.
          </li>
          <li>
            The EMPLOYEE shall not act inadequately due to intimidation by the Client.
          </li>
          <li>
            The EMPLOYEE shall not get influenced by being or believing that they are being, openly
            or secretly coerced by other interested parties.
          </li>
          <li>
            The EMPLOYEE shall not misuse their position, force anyone to provide, for themselves or
            others, money/benefits not due.
          </li>
          <li>
            The EMPLOYEE shall not work under pressure due to late scheduling of activities.
          </li>
        </ul>
      </div>

      <div>
        <strong>ADVOCACY THREATS</strong>
        <ul className="list-disc pl-6">
          <li>
            The EMPLOYEE shall not act in support of, or in opposition to, a given organisation which
            is at the same time its customer, in the resolution of a dispute or litigation.
          </li>
        </ul>
      </div>

      <div>
        <strong>FINANCIAL INTERESTS</strong>
        <ul className="list-disc pl-6">
          <li>The EMPLOYEE shall not risk the inspection contract due to competition threats.</li>
          <li>
            The AIPL shall not link remuneration of its EMPLOYEEs to the volume or outcome of
            inspections performed.
          </li>
          <li>
            The EMPLOYEE shall not give conflicting representation of AIPL and/or its accreditation
            within other areas of the group.
          </li>
          <li>
            The AIPL nor its EMPLOYEE shall not give any payment as sales commission or inducement
            for the referral of new clients to the AIPL or other areas of the business.
          </li>
        </ul>
      </div>

      {/* <div className="grid grid-cols-2 text-center mt-10 pt-10 font-medium">
        <div>
          AIPL
          <br />
          <div className="mt-10">(Signature)</div>
          <div className="mt-2">(Date)</div>
        </div>
        <div>
          {inspectorDetails?.inspectorName || "_____"}<br/>
          EMPLOYEE
          <br />
          <div className="mt-10">(Signature)</div>
          {inspectorDetails?.policyDate || "_____"}
          <div className="mt-2">(Date)</div>
        </div>
      </div> */}

      <div className="grid grid-cols-2 text-center mt-10 pt-10 font-medium">
        {/* Left Side */}
        <div className="flex flex-col items-center">
          <span>AIPL</span>
          <span>Ramesh S Jadhav</span>
          <div className="mt-10">
            <img
              src={SignImg}
              alt="AIPL Signature"
              className="mx-auto h-14"
            />
          </div>
          <div className="mt-2">{inspectorDetails?.policyDate || "_____"}</div>
        </div>

        {/* Right Side */}
        <div className="flex flex-col items-center">
          <span>EMPLOYEE</span>
          <span>{inspectorDetails?.inspectorName || "_____"}</span>
          <div className="mt-10">
            {inspectorDetails?.userSign ? (
              <img
                src={inspectorDetails.userSign}
                alt="Inspector Signature"
                className="mx-auto h-14"
              />
            ) : (
              "(Signature)"
            )}
          </div>
          <div className="mt-2">{inspectorDetails?.policyDate || "_____"}</div>
        </div>
      </div>

      <br />
    </div>
  );
}
